// extracted by mini-css-extract-plugin
export default {"lntSwitch":"styles_lnt-switch__6GCHm"};